
export default (value, min, max, step, asPages) => ({
  value: value * 1,

  normalizeValue() {
    const val = Math.round((parseInt(this.value) || min) / step) * step
    this.value = Math.min(Math.max(val, min), max)
  },

  increment() {
    this.value = Math.min(this.value * 1 + step, max)
  },

  decrement() {
    this.value = Math.max(this.value * 1 - step, min)
  },

  confirm(path) {
    const sheets = asPages ? this.value / 2 : this.value
    Turbo.visit(path.replace(':sheets', sheets))
  },
})
